<script>
import { Doughnut } from 'vue-chartjs'
export default {
	extends: Doughnut,
	props: ['data'],
	watch: {
        data : {
            handler() {
                this.getAvailableWorkspaceTypesCount();
            }
        }
    },
    methods: {
        getAvailableWorkspaceTypesCount() { 
                this.datacollection.labels = [+this.data.cabin_occupied_percent+"%"+" Occupied ("+ this.data.occupied_cabin+")",
                +this.data.cabin_available_percent+"%"+" Available ("+this.data.available_cabin+")"];
                this.datacollection.datasets[0].data[0] = this.data.occupied_cabin;
                this.datacollection.datasets[0].data[1] = this.data.available_cabin;
                this.renderChart(this.datacollection, {responsive: true,maintainAspectRatio: false, legend: {position: 'top',labels: {
                        
                        boxWidth:20,
                        fontSize:13,fontStyle:"bold",
                    }},
                animation: {
                    duration:0
                },
                tooltips:{enabled:true,
                                                            mode:'single',
                                                            callbacks:{label:function(tooltipItems,data){
                                                                
                                                             return data.labels[tooltipItems.index];
                                                            }}}});
        }
    },
    computed: {

    },
    mixins: [Doughnut],
    data(){

        return {
            is_loading: false,
            datacollection: {
                labels: ["orange", "Red", "blue"],
                datasets: [
                  {
                    label: "Data One",
                    backgroundColor: ["#034A81", "#F1631B"],
                    data: [1, 10]
                  }
                ],
            },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    
                    
                }
            
        }

    },
    mounted() {
        this.getAvailableWorkspaceTypesCount();   
    }
 
};
</script>